import React from 'react';
import { useVolunteerAuth } from '../../hooks/useVolunteerAuth';
import { signOutVolunteer } from '../../services/volAuth';
import { useNavigate } from 'react-router-dom';
import './Vol.css';

function VolPendingApproval() {
  const { volunteer, firebaseUser } = useVolunteerAuth();
  const navigate = useNavigate();

  const isDenied = volunteer?.approvalStatus === 'denied';

  const handleSignOut = async () => {
    await signOutVolunteer();
    navigate('/vol/login');
  };

  return (
    <div className="vol-login-page">
      <div className="vol-login-card">
        <div className="vol-login-logo">
          <div className="vol-login-logo-icon" style={{ color: isDenied ? '#dc2626' : '#d97706' }}>
            {isDenied ? '✗' : '⏳'}
          </div>
          <h1>SMPW Masters</h1>
          <p>Volunteer Portal</p>
        </div>

        {isDenied ? (
          <>
            <h2 style={{ color: '#dc2626', margin: '16px 0 8px' }}>Access Not Approved</h2>
            <p style={{ color: '#475569', lineHeight: 1.6, marginBottom: '12px' }}>
              Your volunteer portal access has not been approved at this time.
            </p>
            {volunteer?.approvalNotes && (
              <div className="vol-alert vol-alert-warn" style={{ marginBottom: '16px' }}>
                {volunteer.approvalNotes}
              </div>
            )}
            <p style={{ color: '#64748b', fontSize: '13px' }}>
              Please contact the SMPW scheduling team if you believe this is an error.
            </p>
          </>
        ) : (
          <>
            <h2 style={{ color: '#92400e', margin: '16px 0 8px' }}>Awaiting Approval</h2>
            <p style={{ color: '#475569', lineHeight: 1.6, marginBottom: '12px' }}>
              Your account has been linked to your volunteer registration. A scheduling team member
              will review and approve your access shortly.
            </p>
            <p style={{ color: '#64748b', fontSize: '13px' }}>
              Signed in as <strong>{firebaseUser?.email}</strong>
            </p>
          </>
        )}

        <button className="vol-oauth-btn" style={{ marginTop: '24px' }} onClick={handleSignOut}>
          Sign out
        </button>
      </div>
    </div>
  );
}

export default VolPendingApproval;
